import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import { Icon, type IconType } from "@justhome/react-ui";
export interface TopBarItem {
  label: string;
  mobileLabel?: string;
  href?: string;
  icon?: IconType;
}
export interface TopBarProps {
  fullWidth?: boolean;
  items: TopBarItem[];
}
const Entry = t0 => {
  const $ = _c(11);
  const {
    label,
    mobileLabel,
    icon
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <Icon type={icon} fill="currentColor" className="flex-none" />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = mobileLabel ? "hidden m:inline" : undefined;
  let t3;
  if ($[2] !== label || $[3] !== t2) {
    t3 = <span className={t2}>{label}</span>;
    $[2] = label;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mobileLabel) {
    t4 = mobileLabel && <span className="m:hidden">{mobileLabel}</span>;
    $[5] = mobileLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <>{t1}{t3}{t4}</>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
const TopBar = t0 => {
  const $ = _c(23);
  const {
    items,
    fullWidth
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== fullWidth || $[1] !== items) {
    const claims = items.filter(_temp);
    const actions = items.filter(_temp2);
    t7 = "bg-neutral-675";
    T0 = Container;
    t3 = true;
    t4 = fullWidth;
    t5 = "h-2m flex items-center gap-2xs s:gap-2m text-body-2 font-book text-neutral-100";
    t6 = claims.map(_temp3);
    t1 = "ml-auto flex items-center gap-s";
    t2 = actions.map(_temp4);
    $[0] = fullWidth;
    $[1] = items;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t2) {
    t8 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== T0 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t8) {
    t9 = <T0 padding={t3} fullWidth={t4} className={t5}>{t6}{t8}</T0>;
    $[13] = T0;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default TopBar;
function _temp(item) {
  return !item.href;
}
function _temp2(item_0) {
  return item_0.href;
}
function _temp3(item_1, index) {
  return <span key={`${item_1.label}-${index}`} className={`${item_1.mobileLabel ? "inline-flex" : "hidden s:inline-flex"} items-center gap-3xs`}><Entry {...item_1} /></span>;
}
function _temp4(item_2) {
  return <a key={item_2.label} href={item_2.href} className="inline-flex items-center gap-3xs no-underline transition-colors hover:text-neutral-0"><Entry {...item_2} /></a>;
}